import { Controller } from "@hotwired/stimulus"
import Splide from "@splidejs/splide"

// Splide-powered slider for the home "Kommende aktiviteter" cards.
// The controller element is the .splide root; prev/next live outside the
// root and drive it via splide#prev / splide#next. autoWidth lets each card
// keep its Tailwind width so the next card peeks in, matching the design.
export default class extends Controller {
  static targets = ["prev", "next"]

  connect() {
    this.splide = new Splide(this.element, {
      autoWidth: true,
      gap: "1.5rem",
      perMove: 1,
      arrows: false,
      pagination: false,
      drag: true,
      focus: 0,
      omitEnd: true,
      keyboard: "focused",
      mediaQuery: "min",
      breakpoints: { 1024: { gap: "2.5rem" } },
      label: "Kommende aktiviteter",
      i18n: {
        prev: "Vis forrige aktiviteter",
        next: "Vis næste aktiviteter",
        carousel: "karrusel",
        slide: "aktivitet",
        slideLabel: "%s af %s"
      }
    })

    this.splide.on("mounted move updated", () => this.refresh())
    this.splide.mount()
  }

  disconnect() {
    this.splide?.destroy()
  }

  prev() {
    this.splide.go("<")
  }

  next() {
    this.splide.go(">")
  }

  // Disable the arrows at each end so keyboard and pointer users get the
  // same affordance Splide gives its own arrows.
  refresh() {
    if (!this.hasPrevTarget) return
    const { index } = this.splide
    const end = this.splide.Components.Controller.getEnd()
    this.setDisabled(this.prevTarget, index <= 0)
    this.setDisabled(this.nextTarget, index >= end)
  }

  setDisabled(button, disabled) {
    button.disabled = disabled
    button.classList.toggle("opacity-40", disabled)
  }
}
